import { stringify } from "querystring"

import { LoginLinkResponse } from "./common/interfaces"

import { Analytics } from "utils/analytics"
import { httpClient } from "utils/infrastructure/httpClient"

interface RequestPayload {
    email: string
    name?: string
    promo_code?: string
}

interface FormModel {
    link: string
    request: (
        query: Record<string, string | null | undefined>,
        payload: RequestPayload
    ) => Promise<LoginLinkResponse>
    actionButtonLabel: string
    track: () => void
    errorFallbackLabel: string
    kind: string
}

const LOGIN_LABEL = "Войти"
const REGISTER_LABEL = "Зарегистрироваться"

const loginModel: FormModel = {
    link: "client/auth2/link/login/send",
    request: (query, payload) =>
        httpClient.post<LoginLinkResponse>(`${loginModel.link}?${stringify(query)}`, payload),
    actionButtonLabel: LOGIN_LABEL,
    errorFallbackLabel: REGISTER_LABEL,
    track: () => Analytics.lk_login_current(),
    kind: "login",
}

const registerModel: FormModel = {
    link: "client/auth2/link/register/send",
    request: (query, payload) =>
        httpClient.post<LoginLinkResponse>(`${registerModel.link}?${stringify(query)}`, payload),
    actionButtonLabel: REGISTER_LABEL,
    errorFallbackLabel: LOGIN_LABEL,
    track: () => Analytics.lk_signup(),
    kind: "register",
}

const b2bRegisterModel: FormModel = {
    link: "client/auth2/link/register/b2b/send",
    request: (query, payload) =>
        httpClient.post<LoginLinkResponse>(`${b2bRegisterModel.link}?${stringify(query)}`, payload),
    actionButtonLabel: REGISTER_LABEL,
    errorFallbackLabel: LOGIN_LABEL,
    track: () => Analytics.lk_signup(),
    kind: "b2b-register",
}

export function getFormModel({
    byPromocode,
    isAuthorization,
}: {
    byPromocode?: boolean
    isAuthorization?: boolean
}): FormModel {
    if (isAuthorization) {
        return loginModel
    }
    if (byPromocode) {
        return b2bRegisterModel
    }
    return registerModel
}
